import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Store } from 'src/app/core/store/store';
import { User } from 'src/app/shared/models/user.model';
import { EventsService } from 'src/app/shared/services/events.service';
import { HandleSubscription } from 'src/app/shared/utils/handle-subscription';
import { DashboardService } from '../../services/dashboard.service';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent extends HandleSubscription implements OnInit {
  programData: any;
  user: User;
  showLoaderDashboard = false;
  totalCourses = 0;
  showFeedback = false;
  progCurrentItem: any;
  isProgramCompletionDatePassed = false;
  reloadFromPlayer = false;
  timezoneConfirmation = false;
  showTimezoneConfirmationModal = false;
  activationInfo: any;
  showTermPopup: boolean = true;
  constructor(private dashboardService: DashboardService, private router:Router, private store: Store, private route: ActivatedRoute,
    private titleService: Title, private eventsService: EventsService) {
    super();
    if(this.router.getCurrentNavigation().extras.state && this.router.getCurrentNavigation().extras.state.reload) {
      this.reloadFromPlayer = true;
      window.location.reload();
    }
   }

  ngOnInit(): void {
    if(this.route.snapshot.queryParams && this.route.snapshot.queryParams.accessToken) {
      this.router.navigate([], {
        queryParams: {
          accessToken: null
        },
        queryParamsHandling: 'merge'
      });
    }
    this.showLoaderDashboard = true;
    this.store.select('activationInfo').pipe().subscribe((activation: any) => {
      if(activation) {
        this.activationInfo = activation
        if(this.activationInfo) {
          this.isProgramCompletionDatePassed = this.dashboardService.checkProgramCompletionDatePassed(this.activationInfo);
          
        }
      }
    });
    this.store.select('programData').pipe().subscribe((activation: any) => {
      if(activation) {
        this.showLoaderDashboard = false;
        this.programData = activation
        this.addMasterClassEndDate()
        this.singleCourseCheck(this.programData);
      }
    });
    // this.showLoaderDashboard = true;
    this.callFunctionAfterUserGet()
    // this.getProgramActivation();
    this.store.select('user').pipe(takeUntil(this.unsubscribe$)).subscribe((user: any) => {
      this.user = user;
      if(user){
        // this.callFunctionAfterUserGet()
        if(user['isTimeZoneConfirmed']){
          this.timezoneConfirmation=true;
          this.showTimezoneConfirmationModal=false;
        }else{
          this.showTimezoneConfirmationModal=true;
        }
      }

      if (user && user['isIPJUser'] && user['isPasswordResetRequired']) {
        this.router.navigate(['/info-review']);
      }
    });

    this.getInfosysTerm()
    // this.store.select('activation').pipe(takeUntil(this.unsubscribe$)).subscribe((activation: any) => {
    //   if(activation) {
    //     this.programData = JSON.parse(JSON.stringify(activation));
    //     // this.programData[0]['program']['dashboard'].forEach(element => {
    //     //   console.log(element.title)
    //     //   this.convertTime(element.course_StartDate, this.user['timeZone'])
    //     // });
    //   }
    // });
  }

  addMasterClassEndDate() {
    // find masterclass endDate from duration
    this.programData.map((v) => {
      if (v.type == "MASTERCLASS" && v.masterClassObjects && v.masterClassObjects.length) {
        v.masterClassObjects[0].endDate = this.addMinutes(new Date(v.masterClassObjects[0].date), +v.duration);
      }
    });
    // this.prog = this.program[0]['program'];
  }

  addMinutes(date, minutes) {
    // convert minutes to miliseconds
    return new Date(date.getTime() + minutes * 60000);
  }

  callFunctionAfterUserGet() {
    // console.log(this.user, 'this.user')
    // if(this.user) {
      
    // }
  }

  convertTime(time, zone){
    var d = new Date(time);
    console.log('--------->Old',d)
  console.log('--------->New',new Date(d.setMinutes(d.getMinutes() + this.convertMinutes(zone))).toLocaleDateString('en-US', {weekday : 'long'}));
  }
  convertMinutes(time){
    var timeParts = time.split(':');
    return Number(timeParts[0]) * 60 + Number(timeParts[1]);
  }

  // getProgramActivation() {
  //   let activeProgram=[];
  //   this.dashboardService.getProgramActivation().subscribe(
  //     (res: any) => {
  //       this.showLoaderDashboard = false;
  //       res['data'].forEach(element => {
  //         if(element.isActive){
  //           activeProgram.push(element);
  //         }

  //       });
  //       this.programData = JSON.parse(JSON.stringify(activeProgram));
  //       // this.programData = JSON.parse(JSON.stringify(res['data']));
  //       if(this.programData && this.programData.length && this.programData[0].program && this.programData[0].program.activation && this.programData[0].program.activation.title) {
  //         localStorage.setItem('programTitle', this.programData[0].program.activation.title);
  //         this.titleService.setTitle(this.programData[0].program.activation.title);
  //       }
  //       localStorage.setItem('ActivationData',JSON.stringify(this.programData[0]));
  //       localStorage.setItem("programActivationId", this.programData[0].programActivationId.toString());
  //       this.singleCourseCheck(res);
  //       this.store.set('activation', this.programData);

  //       // check program completion date
  //       if(this.programData && this.programData.length) {
  //         this.isProgramCompletionDatePassed = this.dashboardService.checkProgramCompletionDatePassed(this.programData[0]);
  //       }

  //     }, (error) => {
  //       this.showLoaderDashboard = false;
  //       console.log(error);
  //     }
  //   );
  // }



  getProgramActivation(programActivationId, programId) {
    let opts = {
      "programActivationId": programActivationId,
      "programId": programId,
      "userGroup": this.user?.userGroup
    }
    this.dashboardService.getActivationDashboard(opts).subscribe(res => {
      this.showLoaderDashboard = false;
      this.programData = res.data
      // this.store.set('programData', this.programData)
    })
  }

  singleCourseCheck(res) {
    this.totalCourses = 0;
    for (let i = 0; i < res.length; i++) {
      if (res[i].type === "COURSE") {
        this.totalCourses++;
      }
    }
    if (this.totalCourses === 1) {
      for (let i = 0; i < res.length; i++) {
        if (res[i].type === "COURSE") {
          if(res[i].status.islock == false && res[i].status.progress == 100){
          if(this.activationInfo.enableCourseWiseFeedback && this.activationInfo.enableProgramFeedback && (this.activationInfo.progress == 100) && this.activationInfo.completed && !this.activationInfo.isFeedbackSubmitted) {
            this.showFeedback = true;
          } else {
            this.showFeedback = false;
          }
        }
        }
      }
    } else {
      this.showFeedback = false;
    }
  }

  progCurrentItemBlock(obj) {
    this.progCurrentItem = JSON.parse(JSON.stringify(obj));
  }

  hideTimezoneConfirmationnModal(value) {
    this.showTimezoneConfirmationModal = value;
  }

  getActivationInfo(programActivationId, programId) {
    let opts = {
      programActivationId: programActivationId,
      programId: programId
    }
    this.dashboardService.getActivationInfo(opts).subscribe(res => {
      this.activationInfo =  res.data
      // this.getProgramActivation(programActivationId, programId);
    })
  }

  getInfosysTerm() {
    this.dashboardService.getInfosysTerm().subscribe(res => {
      this.showTermPopup = res.data.isAccepted
    }, error => {

    })
  }
}
